export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA";
export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
export const ADD_REPORT_TO_DASHBOARD = "ADD_REPORT_TO_DASHBOARD";